import { FC } from "react";

export const ArrowUpIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 20.0999C11.6833 20.0999 11.4127 19.9876 11.188 19.7629C10.9627 19.5376 10.85 19.2666 10.85 18.9499V8.2749L6.325 12.7999C6.10833 13.0332 5.84167 13.1499 5.525 13.1499C5.20833 13.1499 4.93333 13.0332 4.7 12.7999C4.48333 12.5666 4.375 12.2999 4.375 11.9999C4.375 11.6999 4.48333 11.4332 4.7 11.1999L11.2 4.6999C11.3167 4.58324 11.4417 4.5039 11.575 4.4619C11.7083 4.42057 11.85 4.3999 12 4.3999C12.15 4.3999 12.296 4.42057 12.438 4.4619C12.5793 4.5039 12.7 4.58324 12.8 4.6999L19.3 11.1999C19.5167 11.4332 19.625 11.6999 19.625 11.9999C19.625 12.2999 19.5167 12.5666 19.3 12.7999C19.0667 13.0332 18.7917 13.1499 18.475 13.1499C18.1583 13.1499 17.8917 13.0332 17.675 12.7999L13.15 8.2749V18.9499C13.15 19.2666 13.0373 19.5376 12.812 19.7629C12.5873 19.9876 12.3167 20.0999 12 20.0999Z"
      fill="currentColor"
    />
  </svg>
);
